<script setup lang="ts">
import { watch } from "vue";

import SidePanel from "@/components/SidePanel/SidePanel.vue";
import SidePanelContent from "@/components/SidePanel/SidePanelContent.vue";
import { useBoardStore } from "@/store/board";
import { useIssueSelectorStore } from "@/store/issueSelector";

import BacklogItemList from "./BacklogItemList.vue";
import IssueList from "./IssueList.vue";

const store = useIssueSelectorStore();
const boardStore = useBoardStore();

// Close panel when board changes (e.g., session change, navigation)
watch(
  () => boardStore.currentBoard()?.id,
  () => {
    if (store.active) {
      store.toggle(false);
    }
  },
);
</script>

<template>
  <SidePanel
    id="issue-selector-panel"
    :active="store.active"
    :resizable="true"
    side="left"
    name="issue-selector"
    class="issue-selector-panel"
    @close="store.toggle(false)"
  >
    <SidePanelContent :title="$t('issueSelector.panelTitle')">
      <div class="selector-container">
        <BacklogItemList />
        <IssueList v-if="store.showAlmItemsSection" />
      </div>
    </SidePanelContent>
  </SidePanel>
</template>

<style lang="scss" scoped>
@use "@/styles/z-index";
@use "@/styles/variables/colors";

.issue-selector-panel {
  z-index: z-index.$menu;
}

.selector-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 8px;
}
</style>
